import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import withTrip from '../withTrip';
import MultiTierSelector from '../../TripDetail/MultiTierSelector';
import { actions as availabilityActions } from '~/redux/reducers/availability';
// import { actions as sessionActions } from '~/redux/reducers/session';
import { actions as tripActions } from '~/redux/reducers/trip';
import { checkTierAvailability } from '~/utils/trip';

const enhance = connect(
  state => ({
    sessionData: state.session.data,
    rates: state.info.exchangeRates,
    selectedMultiTier: state.trip.selectedMultiTier,
    selectedDate: (state.session.data.date || state.availability.selectedDate),
  }),
  (dispatch, props) => ({
    onChangeSubTierQuantity: (sessionData, tiers, subIndex, newQty) => {
      const { trip } = props;
      const selectedMultiTier = tiers.map(tier => ({
        ...tier,
        sub_tiers: [
          ...tier.sub_tiers.slice(0, subIndex),
          {
            ...tier.sub_tiers[subIndex],
            quantity: newQty
          },
          ...tier.sub_tiers.slice(subIndex + 1),
        ]
      }));
      const tier = selectedMultiTier.find(t => t.active);
      const date = moment(sessionData.date).format('MMMM YYYY');
      dispatch(availabilityActions.getTripAvailabilityV2(date, trip._id, tier.sub_tiers.map(st => st.globaltix_ticket_id)));
      dispatch(tripActions.changeSelectedMultiTier(selectedMultiTier));
    },
    onChangeTier: (sessionData, tiers, selectTier) => {
      const { trip } = props;
      const selectedMultiTier = tiers.map(tier => ({
        ...tier,
        active: tier.tier === selectTier,
        sub_tiers: tier.sub_tiers.map((subTier, subIndex) => ({
          ...subTier,
          quantity: tier.tier === selectTier && subIndex === 0 ? 2 : 0
        }))
      }));
      const tier = selectedMultiTier.find(t => t.active);
      const date = moment(sessionData.date).format('MMMM YYYY');
      dispatch(availabilityActions.getTripAvailabilityV2(date, trip._id, tier.sub_tiers.map(st => st.globaltix_ticket_id)));
      dispatch(tripActions.changeSelectedMultiTier(selectedMultiTier));
    },
    changeSelectedMultiTier: (selectedMultiTier) => dispatch(tripActions.changeSelectedMultiTier(selectedMultiTier)),
  })
);

class TicketQuantitySelector extends React.Component {
  componentDidMount() {
    this.getTiers();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedDate !== this.props.selectedDate) {
      this.getTiers();
    }
  }

  getTiers = () => {
    const tripSelectedMultiTier = this.props.trip.multi_tier_prices
      .filter(tier => checkTierAvailability(tier, this.props.selectedDate))
      .map((tier, idx) => ({
        ...tier,
        active: idx === 0,
        sub_tiers: tier.sub_tiers.map((subTier, subIndex) => ({
          ...subTier,
          quantity: subIndex === 0 ? 2 : 0
        }))
      }));
    this.props.changeSelectedMultiTier(tripSelectedMultiTier);
  }

  render() {
    const { sessionData, rates, onChangeSubTierQuantity, onChangeTier, selectedMultiTier } = this.props;
    const { currency } = sessionData;

    return (
      <MultiTierSelector
        currency={currency}
        onChangeSubTierQuantity={(subIndex, newQty) => onChangeSubTierQuantity(sessionData, selectedMultiTier, subIndex, newQty)}
        onChangeTier={(selectTier) => onChangeTier(sessionData, selectedMultiTier, selectTier)}
        rates={rates}
        selectedMultiTier={selectedMultiTier}
      />
    );
  }
}

TicketQuantitySelector.propTypes = {
  sessionData: PropTypes.object,
  rates: PropTypes.object,
  trip: PropTypes.object,
  onChangeSubTierQuantity: PropTypes.func,
  onChangeTier: PropTypes.func,
  selectedMultiTier: PropTypes.object,
  selectedDate: PropTypes.string,
};

export default withTrip(enhance(TicketQuantitySelector));
